import { useState } from 'react';
import { useSelector } from 'react-redux';
import OrdersList from '../List/OrdersList';
import TableTitle from '../../Shared/Table/widgets/TableTitle';
import TablePageContainer from '../../Shared/Table/widgets/TablePageContainer';

const Orders = () => {
  const { en } = useSelector((state) => state.i18n);
  const { titles: tTitles } = en;
  const [filterStyle, setFilterStyle] = useState(false);
  const [totalCount, setTotalCount] = useState(' ');

  return <TablePageContainer>
    <OrdersList
      setFilterStyle={setFilterStyle}
      setTotalCount={setTotalCount}
      tableTitle={<TableTitle
        titleText={tTitles.orders}
        count={totalCount}
        countFiltered={filterStyle}
      />}
    />
  </TablePageContainer>;
};

export default Orders;
